export default __webpack_public_path__ + "static/media/Create-documentation.a0cda9cf.md";